"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var image_1 = require("@syl-editor/lib/dist/lib/formats/image");
var card_1 = require("../../../card");
var mask_1 = require("./mask");
var template_1 = require("./template");
require("./style.css");
var ImageView = /** @class */ (function (_super) {
    __extends(ImageView, _super);
    function ImageView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ViewMap = {
            template: template_1.ImageComponent,
            mask: mask_1.ImageMask
        };
        _this.renderer = _this.mount({ name: 'image' });
        return _this;
    }
    ImageView = __decorate([
        core_utilities_1.configuration(image_1.Image.configuration)
    ], ImageView);
    return ImageView;
}(card_1.Card));
exports.ImageView = ImageView;
var InlineImageView = /** @class */ (function (_super) {
    __extends(InlineImageView, _super);
    function InlineImageView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ViewMap = {
            template: template_1.InlineImageComponent,
            mask: mask_1.ImageMask
        };
        _this.renderer = _this.mount({ name: 'image' });
        return _this;
    }
    InlineImageView = __decorate([
        core_utilities_1.configuration(image_1.Image.configuration)
    ], InlineImageView);
    return InlineImageView;
}(card_1.InlineCard));
exports.InlineImageView = InlineImageView;
//# sourceMappingURL=index.js.map